//Modules
import React from "react"
//Styles
import { StyledContainer } from "../../Elements"
//Components
import Accordion from "./Accordion"
import Testimonials from "./Testimonials"

const Qualifications = ({ testimonials, qualifications }) => {
  return (
    <StyledContainer>
      <h1>Qualifications</h1>
      <Accordion qualifications={qualifications} />
      <h1>Some kind words for me</h1>
      <Testimonials testimonialData={testimonials} />
    </StyledContainer>
  )
}

export default Qualifications
